<template>
  <div>
    <div class="content">
      <div class="service_content">
        <p class="title">服务</p>
        <div class="text_content">
          <p class="small_title2"><span>渠道一：线上服务</span></p>
          <div class="text inline">
            <p>线上服务是文华服务用户的主流渠道。</p>
            <p>
             线上服务配备一支专业金融工程师团队，每日14个小时的在线值守，解答投资者提出的各种软件使用问题。
            </p>
            <p>
              每天我们处理上千个用户的提问，上一个年度我们解答了<common-data name="countBBSUser" v-common-display/>个用户的问题。
            </p>
            <p>
              <!-- 金融工程师团队成员，由具有金融类本科学历、持有期货从业资格证的专业人员组成。 -->
              金融工程师团队成员，由具有金融相关本科学历、持有期货从业资格考试合格证书的专业人员组成。
            </p>
            <p class="tips">
              线上服务入口：软件界面的右上角菜单，[帮助]－>在线客服
            </p>
          </div>
          <div class="inline" style="padding-top: 20px; padding-left: 60px">
            <img src="../../assets/img/lunt.png" />
          </div>
        </div>

        <div class="text_content">
          <p class="small_title2"><span>渠道二：电话服务</span></p>
          <div class="text inline">
            <p>呼叫中心配备一支金融工程师团队，接听用户电话，解决用户问题。</p>
            <p>
              <!-- 金融工程师团队成员，由具有金融类本科学历、持有证券从业资格证的专业人员组成。 -->
              金融工程师团队成员，由具有金融相关本科学历、持有期货从业资格考试合格证书的专业人员组成。
            </p>
            <p class="tips" v-common-display>
              VIP客服电话：<common-data name="serviceTel" /><span style="color: #6f6f6f"
                >（<common-data name="serviceTime" />）</span
              >
            </p>
          </div>
          <div class="inline" style="padding-top: 20px; padding-left: 60px">
            <img src="../../assets/img/Vip_mpic2.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.content {
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=15) no-repeat top;
  width: 100%;
  min-height: 600px;
  padding-top: 236px;
}
.service_content {
  width: 990px;
  margin: 0 auto;
  background: #fff;
  border-radius: 5px;
  padding: 30px;
  box-shadow: 0 0 20px -5px #ccc;
  min-height: 600px;
}
.service_content .title {
  color: #5f5f5f;
  border-bottom: 1px dashed #a8a8a8;
  line-height: 40px;
  font-size: 22px;
}
.text_content {
  padding-top: 20px;
}

.text_content .small_title {
  color: #806049;
  background-color: #f7e1d3;
  display: block;
  border-radius: 5px;
  width: 46px;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  position: relative;
  top: 5px;
}
.text_content .small_title2 {
  color: #ffffff;
  background-color: #f5e5e5;
  font-size: 16px;
  line-height: 36px;
  font-weight: 500;
}
.text_content .small_title2 span {
  background-color: #e04a49;
  display: block;
  height: 36px;
  width: 160px;
  border-radius: 0 0 36px 0;
  padding-left: 20px;
}
.text_content .text {
  width: 600px;
  padding-top: 20px;
  padding-left: 20px;
}
.text_content .text p {
  font-size: 14px;
  color: #6f6f6f;
  line-height: 30px;
  text-indent: 2em;
}
.text .tips {
  color: #4d2f2d !important;
  text-indent: 0 !important;
  font-weight: bold;
}
.inline {
  display: inline-block;
  vertical-align: top;
}
</style>